import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface PumpTableProps {
  rows: {
    id: string
    site: string
    description: string
    controller: string
    active: string
    pipe: string
    priority: string
    io: string
    start_delay: string
    stop_delay: string
    capacity: string
  }[]
}

const PumpTable: FC<PumpTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Pump
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Site
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Decoder
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Active
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Pipe
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Priority
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                IO
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Start Delay(sec)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Stop Delay(sec)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '111.42px',
                }}
              >
                Capacity (l/m)
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '111.42px',
                  borderLeft: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell>{row.site}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.controller}</TableCell>
                <TableCell>{row.active}</TableCell>
                <TableCell>{row.pipe}</TableCell>
                <TableCell>{row.priority}</TableCell>
                <TableCell>{row.io}</TableCell>
                <TableCell>{row.start_delay}</TableCell>
                <TableCell>{row.stop_delay}</TableCell>
                <TableCell>{row.capacity}</TableCell>
                <TableCell
                  sx={{
                    borderLeft: '1px solid #D7D7D7',
                  }}
                >
                  <Stack direction="row" spacing="10px">
                    <Typography
                      sx={{
                        fontSize: '13px',
                        fontWeight: '500',
                        lineHeight: '100%',
                        color: 'primary.main',
                        cursor: 'pointer',
                      }}
                    >
                      EDIT
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '13px',
                        fontWeight: '500',
                        lineHeight: '100%',
                        color: 'grey.600',
                        cursor: 'pointer',
                      }}
                    >
                      DELETE
                    </Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default PumpTable
